import React from 'react';

import Fact from './Fact';

function HoC(props) {
  return (
    <Fact id="nyckelhalet" title="Nyckelhålet" {...props}>
      <p>
        <a
          rel="noopener noreferrer"
          target="_blank"
          href="https://www.livsmedelsverket.se/globalassets/om-oss/lagstiftning/livsmedelsinfo-till-konsum---markning/livsfs-2015-1-web.pdf"
        >
          {`
            Här hittar du reglerna för Nyckelhålet där de 33
            livsmedelsgrupperna och min-/maxvärden för varje
            livsmedelsgrupp finns beskrivet.
          `}
        </a>
      </p>
    </Fact>
  );
}

export default HoC;



// WEBPACK FOOTER //
// ./src/components/Fact/FactNyckelhalet.js